module.exports = __webpack_public_path__ + "fonts/MuseoSansCyrl-500.041dcbc9.woff";